import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Subscription } from 'rxjs';
import { ApiService } from "src/app/services/api.service";


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.less']
})
export class ProfileComponent implements OnInit {
  
  currentCompany: any = null
  currentCompanyId: any = null
  currentUser: any = null
  companyData: any = null
  userData: any = null
  notificationsPlatforms: any =null
  subscription: Subscription;
  constructor(private dataService: DataService, private _api: ApiService,) {

    if (localStorage.getItem('currentCompany')) {
      let company = JSON.parse(localStorage.getItem('currentCompany'));
      this.currentCompany = company.name
      this.currentCompanyId = company._id
    }
  }

  ngOnInit(): void {
    let user = localStorage.getItem('user');
    this.currentUser = user
    this.fetchData(this.currentCompanyId)
  }

  fetchData(companyId) {
    console.log(companyId)
    this._api.get<any>(`/company/${companyId}`).subscribe(resp => {
      console.log(resp)
      this.companyData = resp.data.company
      this.userData = resp.data.user
  }, err => {
      alert(err.message);
  });
  }

  // ngOnDestroy() {
  //   this.subscription.unsubscribe();
  // }


}
